/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_UpdatedInputs */

const en_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic backup settings updated.`)
};

const fr_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de sauvegarde automatique mis à jour.`)
};

const de_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Sicherungseinstellungen aktualisiert.`)
};

const it_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di backup automatico aggiornate.`)
};

const ru_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлены настройки автоматического резервного копирования.`)
};

const es_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de copia de seguridad automática actualizada.`)
};

const zh_cn2_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动备份设置已更新。`)
};

const ja_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップ設定が更新されました。`)
};

const hi_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित बैकअप सेटिंग्स अपडेट हो गईं।`)
};

const pt_pt2_options_backup_updated = /** @type {(inputs: Options_Backup_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de backup automático atualizadas.`)
};

/**
* | output |
* | --- |
* | "Automatic backup settings updated." |
*
* @param {Options_Backup_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_updated = /** @type {((inputs?: Options_Backup_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_updated(inputs)
	if (locale === "de") return de_options_backup_updated(inputs)
	if (locale === "it") return it_options_backup_updated(inputs)
	if (locale === "ru") return ru_options_backup_updated(inputs)
	if (locale === "es") return es_options_backup_updated(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_updated(inputs)
	if (locale === "ja") return ja_options_backup_updated(inputs)
	if (locale === "hi") return hi_options_backup_updated(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_updated(inputs)
	return en_options_backup_updated(inputs)
});